import Inicio from './paginas/Inicio.svelte';
import Suporte from './paginas/Suporte.svelte';
import Erro404 from './paginas/Erro404.svelte';

// seguranca
import Login from './paginas/seguranca/Login.svelte';
import AtivacaoConta from './paginas/seguranca/AtivacaoConta.svelte';
import RecuperarAcesso from './paginas/seguranca/RecuperarAcesso.svelte';
import ResetarSenha from './paginas/seguranca/ResetarSenha.svelte';
import SenhaProvisoria from './paginas/seguranca/SenhaProvisoria.svelte';

// paineis
import PainelPrincipal from './paginas/paineis/PainelPrincipal.svelte';
import PainelUsuarios from './paginas/paineis/PainelUsuarios.svelte';
import PainelUsuariosOpecoesListagem from './paginas/paineis/PainelUsuariosOpecoesListagem.svelte';
import PainelProjetos from './paginas/paineis/PainelProjetos.svelte';
import PainelProjetosOpecoesListagem from './paginas/paineis/PainelProjetosOpecoesListagem.svelte';
import PainelBancoAfirmacoes from './paginas/paineis/PainelBancoAfirmacoes.svelte';
import PainelDistribuicao from './paginas/paineis/PainelDistribuicao.svelte';
import PainelAvaliacao from './paginas/paineis/PainelAvaliacao.svelte';
import PainelClassificacaoOpecoesListagem from './paginas/paineis/PainelClassificacaoOpecoesListagem.svelte';
import PainelGrupos from './paginas/paineis/PainelGrupos.svelte';
import PainelGruposOpcoesListagem from './paginas/paineis/PainelGruposOpcoesListagem.svelte';
import PainelConfiguracoes from './paginas/paineis/PainelConfiguracoes.svelte';
import PainelConsultaPublica from './paginas/paineis/PainelConsultaPublica.svelte';

// usuarios
import Cadastro from './paginas/usuarios/Cadastro.svelte';
import Atualizacao from './paginas/usuarios/Atualizacao.svelte';
import Visualizar from './paginas/usuarios/Visualizar.svelte';
import ListagemGeral from './paginas/usuarios/ListagemGeral.svelte';
import ListagemPorPerfil from './paginas/usuarios/ListagemPorPerfil.svelte';
import MeusProjetos from './paginas/usuarios/MeusProjetos.svelte';
import ConfirmarAlteracaoPerfil from './paginas/usuarios/ConfirmarAlteracaoPerfil.svelte';
import ConfirmarDefinirNivelAdministrador from './paginas/usuarios/ConfirmarDefinirNivelAdministrador.svelte';
import ListagemProjetosPorCPF from './paginas/usuarios/ListagemProjetosPorCPF.svelte';
import ListagemDistribuicoesPorCPF from './paginas/usuarios/ListagemDistribuicoesPorCPF.svelte';
import ListagemAvaliacoesPorCPF from './paginas/usuarios/ListagemAvaliacoesPorCPF.svelte';

// projetos
import CadastroProjeto from './paginas/projetos/CadastroProjeto.svelte';
import CadastroRelatorioProjeto from './paginas/projetos/CadastroRelatorioProjeto.svelte';
import AtualizacaoProjeto from './paginas/projetos/AtualizacaoProjeto.svelte';
import AtualizacaoRelatorioProjeto from './paginas/projetos/AtualizacaoRelatorioProjeto.svelte';
import ListagemProjetos from './paginas/projetos/ListagemProjetos.svelte';
import ListagemProjetosPorModalidade from './paginas/projetos/ListagemProjetosPorModalidade.svelte';
import VisualizarProjeto from './paginas/projetos/VisualizarProjeto.svelte';
import VisualizarApresentacao from './paginas/projetos/VisualizarApresentacao.svelte';
import VisualizarResumoApresentacao from './paginas/projetos/VisualizarResumoApresentacao.svelte';
import ImpressaoProjeto from './paginas/projetos/ImpressaoProjeto.svelte';
import VisualizarProjetoAnonimizado from './paginas/projetos/VisualizarProjetoAnonimizado.svelte';
import IndicacaoDiscente from './paginas/projetos/IndicacaoDiscente.svelte';
import IndicacaoBolsista from './paginas/projetos/IndicacaoBolsista.svelte';
import IndicacaoCoordenador from './paginas/projetos/IndicacaoCoordenador.svelte';

// grupos
import CadastroGrupo from './paginas/grupos/CadastroGrupo.svelte';
// import ListagemGrupo from './paginas/grupos/ListagemGrupo.svelte';
// import VisualizarGrupo from './paginas/grupos/VisualizarGrupo.svelte';

import ListagemBolsistas from './paginas/projetos/ListagemBolsistas.svelte';
import ConfirmacaoAlterarStatusParticipante from './paginas/projetos/ConfirmacaoAlterarStatusParticipante.svelte';
import ConfirmacaoSolicitacaoRenovacao from './paginas/projetos/ConfirmacaoSolicitacaoRenovacao.svelte';
import Classificacao from './paginas/projetos/Classificacao.svelte';
import CadastroApresentacao from './paginas/projetos/CadastroApresentacao.svelte';
import ListagemApresentacoes from './paginas/projetos/ListagemApresentacoes.svelte';

// formulário serve para anexos de usuários e de projetos
import FormularioAdicionarAnexo from './paginas/formularios/FormularioAdicionarAnexo.svelte';

// busca
import ResultadoBusca from './paginas/usuarios/ResultadoBusca.svelte';
import ResultadoBuscaProjeto from './paginas/projetos/ResultadoBuscaProjeto.svelte';
import FormularioBusca from './paginas/busca/FormularioBusca.svelte';
import ResultadoBuscaConsultaPublicaUsuarios from './paginas/ResultadoBuscaConsultaPublicaUsuarios.svelte';
import ResultadoBuscaConsultaPublicaProjetos from './paginas/ResultadoBuscaConsultaPublicaProjetos.svelte';
import ResultadoBuscaConsultaPublicaProjetosPaginado from './paginas/ResultadoBuscaConsultaPublicaProjetosPaginado.svelte';

// banco de afirmações
import CadastroAfirmacao from './paginas/afirmacoes/CadastroAfirmacao.svelte';
import ListagemAfirmacoes from './paginas/afirmacoes/ListagemAfirmacoes.svelte';
import ConfirmacaoAtivarDesativar from './paginas/afirmacoes/ConfirmacaoAtivarDesativar.svelte';

// distribuicao
import ConfirmarExecucaoDistribuicao from './paginas/distribuicao/ConfirmarExecucaoDistribuicao.svelte';
import DistribuicaoManual from './paginas/distribuicao/DistribuicaoManual.svelte';
import ConfirmarDesfazerDistribuicao from './paginas/distribuicao/ConfirmarDesfazerDistribuicao.svelte';
import ConfirmarAceiteOuRecusaDistribuicao from './paginas/distribuicao/ConfirmarAceiteOuRecusaDistribuicao.svelte';
import ListagemDistribuicao from './paginas/distribuicao/ListagemDistribuicao.svelte';
import ListagemDistribuicaoPorAvaliador from './paginas/distribuicao/ListagemDistribuicaoPorAvaliador.svelte';
import ListagemFalhasDistribuicao from './paginas/distribuicao/ListagemFalhasDistribuicao.svelte';
import ListagemFalhasDistribuicaoApresentacoes from './paginas/distribuicao/ListagemFalhasDistribuicaoApresentacoes.svelte';
import ListagemDistribuicaoAguardandoAceite from './paginas/distribuicao/ListagemDistribuicaoAguardandoAceite.svelte';
import ListagemDistribuicaoAguardandoAceiteVisaoAdministrador from './paginas/distribuicao/ListagemDistribuicaoAguardandoAceiteVisaoAdministrador.svelte';

// avaliações
import ListagemAvaliacoes from './paginas/avaliacao/ListagemAvaliacoes.svelte';
import ListagemAvaliacoesAvaliador from './paginas/avaliacao/ListagemAvaliacoesAvaliador.svelte';
import FormularioAvaliacao from './paginas/avaliacao/FormularioAvaliacao.svelte';
import VisualizarAvaliacao from './paginas/avaliacao/VisualizarAvaliacao.svelte';
import VisualizarAvaliacaoAnonimizada from './paginas/avaliacao/VisualizarAvaliacaoAnonimizada.svelte';

// configurações
import ListagemConfiguracoesAPI from './paginas/configuracoes/ListagemConfiguracoesAPI.svelte';
import ListagemConfiguracoesApp from './paginas/configuracoes/ListagemConfiguracoesApp.svelte';
import FormularioAtualizarConfiguracao from './paginas/configuracoes/FormularioAtualizarConfiguracao.svelte';
import LimpezaCache from './paginas/configuracoes/LimpezaCache.svelte';
import GeradorRelatorios from './paginas/configuracoes/GeradorRelatorios.svelte';

// paginas genericas
import Prazos from './paginas/Prazos.svelte';
import AvisoConsentimento from './paginas/AvisoConsentimento.svelte';

export default {
	'/':  Inicio,
	'/suporte': Suporte,
	
	'/login':  Login,
	'/acesso/recuperacao': RecuperarAcesso,
	'/acesso/ativacao': AtivacaoConta,
	'/acesso/senha/reset': ResetarSenha,
	'/acesso/senha/provisoria/:cpf/:id': SenhaProvisoria,
	
	'/busca/formulario/:tipo': FormularioBusca,

	'/painel': PainelPrincipal,
	'/painel/usuarios': PainelUsuarios,
	'/painel/projetos': PainelProjetos,
	'/painel/relatorios': GeradorRelatorios,
	'/painel/banco-afirmacoes': PainelBancoAfirmacoes,
	'/painel/distribuicao': PainelDistribuicao,
	'/painel/avaliacao': PainelAvaliacao,
	'/painel/configuracoes': PainelConfiguracoes,
	'/painel/grupos': PainelGrupos,
	'/painel/classificacao': PainelClassificacaoOpecoesListagem,
	'/painel/classificacao/listagem/:tipo': Classificacao,
	
	'/usuario/cadastro': Cadastro,
	'/usuario/listagem': PainelUsuariosOpecoesListagem,
	'/usuario/listagem/geral': ListagemGeral,
	'/usuario/listagem/perfil/:perfil': ListagemPorPerfil,
	'/usuario/atualizacao/:cpf': Atualizacao,
	'/usuario/visualizar/:cpf': Visualizar,
	
	'/usuario/resultado/busca': ResultadoBusca,
	'/usuario/meus-projetos': MeusProjetos,
	'/usuario/listagem/projetos/:cpf': ListagemProjetosPorCPF,
	'/usuario/listagem/distribuicoes/:cpf': ListagemDistribuicoesPorCPF,
	'/usuario/listagem/avaliacoes/:cpf': ListagemAvaliacoesPorCPF,
	
	'/usuario/perfil/atualizacao/:cpf/:idUsuario/:perfisCadastradosBase64': ConfirmarAlteracaoPerfil,
	'/usuario/cadastro/configurar-acesso-admin/:cpf': ConfirmarDefinirNivelAdministrador,
	'/usuario/anexos/adicionar/:cpf': FormularioAdicionarAnexo,

	'/projeto/cadastro': CadastroProjeto,
	'/projeto/listagem': PainelProjetosOpecoesListagem,
	'/projeto/listagem/geral': ListagemProjetos,
	'/projeto/listagem/apresentacoes': ListagemApresentacoes,
	'/projeto/listagem/modalidade/:modalidade': ListagemProjetosPorModalidade,
	'/projeto/relatorios/cadastro/:codigoProjeto/:idProjeto/:modalidade?tp=tituloProjetoBase64': CadastroRelatorioProjeto,
	'/projeto/relatorios/atualizacao/:codigoProjeto/:idProjeto/:idRelatorio?tp=tituloProjetoBase64': AtualizacaoRelatorioProjeto,
	'/projeto/atualizacao/:codigo': AtualizacaoProjeto,
    '/projeto/visualizar/:codigo': VisualizarProjeto,
	'/projeto/imprimir/:codigo': ImpressaoProjeto,
    '/projeto/visualizar/anonimizado/:codigo/:idAvaliacao': VisualizarProjetoAnonimizado,
	'/projeto/resultado/busca': ResultadoBuscaProjeto,
	'/projeto/indicar-discente': IndicacaoDiscente,
	'/projeto/indicar-bolsista': IndicacaoBolsista,
	'/projeto/indicar-coordenador': IndicacaoCoordenador,
	'/projeto/bolsistas': ListagemBolsistas,
	'/projeto/participantes/ativar-inativar/:idProjeto/:idParticipante/:ativarOuInativar/:codigoProjeto': ConfirmacaoAlterarStatusParticipante,
	'/projeto/anexos/adicionar/:codigo': FormularioAdicionarAnexo,
	'/projeto/solicitacoes/renovacao/:codigoProjeto': ConfirmacaoSolicitacaoRenovacao,
	'/projeto/apresentacao': CadastroApresentacao,
	'/apresentacao/visualizar/:id/:codigoProjeto': VisualizarApresentacao,
	'/banco-afirmacoes/cadastro': CadastroAfirmacao,
	'/banco-afirmacoes/listagem': ListagemAfirmacoes,
	'/banco-afirmacoes/ativar-desativar/:idAfirmacao/:ativarOuDesativar': ConfirmacaoAtivarDesativar,

	'/distribuicao/executar': ConfirmarExecucaoDistribuicao,
	'/distribuicao/manual': DistribuicaoManual,
	'/distribuicao/desfazer/confirmacao/:id': ConfirmarDesfazerDistribuicao,
	'/distribuicao/listagem': ListagemDistribuicao,
	'/distribuicao/listagem-por-avaliador/:flagTipoObjetoListado': ListagemDistribuicaoPorAvaliador,
	'/distribuicao/listagem-aguardando-aceite-admin/:flagTipoObjetoListado': ListagemDistribuicaoAguardandoAceiteVisaoAdministrador,
	'/distribuicao/falhas-projeto': ListagemFalhasDistribuicao,
	'/distribuicao/falhas-apresentacao': ListagemFalhasDistribuicaoApresentacoes,

	// pro avaliador, a distribuição será exibida como um avaliação pendente de aceite
	'/distribuicao/listagem-aguardando-aceite': ListagemDistribuicaoAguardandoAceite,
	'/distribuicao/confirmacao-aceite-ou-recusa-avaliacao/:codigoProjeto/:idDistribuicao?p=payload': ConfirmarAceiteOuRecusaDistribuicao,

	'/avaliacao/listagem/avaliador/status/:status': ListagemAvaliacoesAvaliador,
	'/avaliacao/listagem/:status?': ListagemAvaliacoes,
	'/avaliacao/preencher-formulario-avaliacao/:idObjetoAvaliado/:idAvaliacao': FormularioAvaliacao,
	'/avaliacao/visualizar/:id': VisualizarAvaliacao,
	'/avaliacao/visualizar/anonimizada/:id': VisualizarAvaliacaoAnonimizada,

	// rotas de grupos
	'/grupos/cadastro/': CadastroGrupo,
	'/grupos/listagem': PainelGruposOpcoesListagem,
	// '/grupos/listagem/:tipoGrupo': ListagemGrupo,
	// '/grupos/visualizar/:id': VisualizarGrupo,

	// rotas dos anais semana de graduação
	'/sdg/trabalhos': PainelConsultaPublica,
	'/sdg/trabalhos/consulta/usuarios': ResultadoBuscaConsultaPublicaUsuarios,
	'/sdg/trabalhos/consulta/projetos': ResultadoBuscaConsultaPublicaProjetos,
	'/sdg/trabalhos/consulta/projetos/listagem/:tipoConsulta/:termo': ResultadoBuscaConsultaPublicaProjetosPaginado,
	'/sdg/trabalhos/visualizar/resumo/:id/:codigoProjeto': VisualizarResumoApresentacao,
	// configurações da api (impacto global)
	'/painel/configuracoes/back-end/:tipo?': ListagemConfiguracoesAPI,

	// configurações do app (impacto local)
	'/painel/configuracoes/front-end/:tipo?': ListagemConfiguracoesApp,
	
	// form para atualização das variáveis
	'/painel/configuracoes/atualizar/:variavel/:escopo': FormularioAtualizarConfiguracao,
	
	// rotas abertas gerais
	'/limpeza-aplicacao/:numeroAleatorio?m=mensagemBase64': LimpezaCache,
	'/prazos': Prazos,
	'/confirmacao-aceite-termos': AvisoConsentimento,
	
	// deve ficar por último pois pega toda url que não estiver nas definições acima
	'*': Erro404
};